import { ErrorMessage, Field } from '@atlaskit/form';
import Select, { OptionsType, ValueType } from '@atlaskit/select';
import React from 'react';
import { LineItemSelect } from '@atlassian/cssxp-types-billing';

interface Props {
  options: OptionsType<LineItemSelect>;
  fieldName?: string;
  fieldLabel?: string;
  placeholder?: string;
  errorMessage?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
}

export const validate = (value: any) => (!value ? 'EMPTY' : undefined);

export const getErrorMessage = (error: any, errorMessage: string) =>
  error && <ErrorMessage>{errorMessage}</ErrorMessage>;

export const getValidationState = (error: any) => (error ? 'error' : 'default');

export const MultipleLineItemFormField = ({
  options,
  fieldName = 'lineItems',
  fieldLabel = 'Invoice line items',
  placeholder = 'Select line items',
  errorMessage = 'Please select line items',
  isRequired = false,
  isDisabled = false,
}: Props) => {
  if (!options) {
    return null;
  }

  return (
    <>
      <Field<ValueType<LineItemSelect>>
        name={fieldName}
        label={fieldLabel}
        isRequired={isRequired}
        validate={validate}
        isDisabled={isDisabled}
      >
        {({ fieldProps, error }) => (
          <div data-testid="multiple-lineitems-field">
            <Select<LineItemSelect>
              {...fieldProps}
              className="multiple-lineitems-field"
              classNamePrefix="multiple-lineitems-field"
              id={fieldProps.id}
              options={options}
              placeholder={placeholder}
              //@ts-ignore
              isMulti={true}
              validationState={getValidationState(error)}
            />
            {getErrorMessage(error, errorMessage)}
          </div>
        )}
      </Field>
    </>
  );
};
